<script>
import StoryCardClickBehavior from "%/dynamic-component-editor/options/story-card-click-behavior";
import KeepSpaceWithoutCover from "%/dynamic-component-editor/options/keep-space-without-cover";
import CustomLinkImageElement
  from "%/dynamic-component-editor/standard-elements/image-element/CustomLinkImageElement.vue";
import {
  BaseStoryCardElementMixin,
} from "%/dynamic-component-editor/standard-components/base-story-card/base-story-card-element-mixin";
const MEMBER_POST_STORY_TYPE = "ugc";

export default {
  name: "StoryImage",
  extends: CustomLinkImageElement,
  mixins: [BaseStoryCardElementMixin],
  elementPanelSettings: {
    displayName: "Story Thumbnail",
    displayIcon: "image",
    elementType: "element",
    elementGroup: "storyElements",
  },
  options: [
    StoryCardClickBehavior,
    KeepSpaceWithoutCover,
  ],
  computed: {
    showImagePlaceholder() {
      if (this.editMode) {
        return true;
      }
      return !this.imageSrc && !this.isMemberPost && this.getOptionValue(KeepSpaceWithoutCover);
    },
    placeholderImageSrc() {
      if (this.editMode || this.isMemberPost) {
        return undefined;
      }
      return "data:image/svg+xml,%3Csvg%20xmlns='http://www.w3.org/2000/svg'%20width='500'%20height='500'%2F%3E";
    },
    isMemberPost() {
      return this.entity?.storyType === MEMBER_POST_STORY_TYPE;
    },
    imageHref() {
      return this.storyHref;
    },
    thumbnail() {
      return this.entity.thumbnail;
    },
    imageSrc() {
      if (this.thumbnail) {
        return this.thumbnail;
      }
      return this.fallbackImageSrc;
    },
  },
};
</script>
